import * as yup from "yup";
import { useRef } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormConteoPublico } from "../abm/actividades/FormConteoPublico";
import { useAbm } from "../../services";

const schema = yup.object().shape({
  conteo_publico: yup.number().integer().min(0).required().label("Conteo de público")
});

export const ModalConteoPublicoActividad = ({
  showState = [false, () => {}],
  params = {},
  selectedItem,
  loadDetails
}) => {
  const [show, setShow] = showState;
  const formRef = useRef();
  const service = useAbm({entity: "actividades"});

  const handleCancel = () => setShow(false);

  const handleConfirm = async (formData) => {
    await service.update(
      {conteo_publico: formData.conteo_publico},
      params?.id,
      "actividades/conteo-publico"
    );

    await loadDetails(selectedItem?.id || params?.id);
    setShow(false);
  };

  return (
    <Dialog open={show} onClose={handleCancel} keepMounted={false}>
      <DialogTitle>Conteo de público</DialogTitle>
      <DialogContent>
        <FormConteoPublico
          ref={formRef}
          item={{conteo_publico: params?.value ?? ""}}
          schema={schema}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="success" onClick={event => formRef.current?.submit(event)}>
          Guardar
        </Button>
        <Button variant="outlined" color="error" onClick={handleCancel}>
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
